import React, { useContext, useEffect, useState } from 'react'
import { ButtonsDiv, CloseDiv, CloseImg, Container, CreateButtonDiv, CreateButtonImage, CreateButtonText, ErrorMessage, HeaderDiv, HeaderText, InputDiv, InputProfileName, LabelCreate, TipText } from './style'
import cross from '../../assets/addStockModal/cross.svg'
import plus from '../../assets/headers/plus.svg'
import ModalContext from '../../contexts/ModalContext'
import ApiService from '../../services/ApiService'
import { useProfileContext } from '../../contexts/AccessesContext'

const CreateProfile:React.FC = () => {

  const [ profileName, setProfileName ] = useState('')
  const { setModalActive, editingProfile } = useContext(ModalContext)
  const { newProfiles, setNewProfiles } = useProfileContext()
  const [correctName, setCorrectName] = useState(false)
  const [click, setClick] = useState(false)
  const [error, setError] = useState(false)
  const [isReservedName, setIsReservedName] = useState(false)

  interface CreateProfileData {
    name:string
  }

  useEffect(() => {
    const trimmedName = profileName.trim()
    const isReserved = trimmedName.toUpperCase() === 'ADM'
    
    setIsReservedName(isReserved)
    setError(false) // Reset error when user types
    
    if(trimmedName.length <= 2 || isReserved){
      setCorrectName(false)
    }else{
      setCorrectName(true)
    }
  }, [profileName])

  useEffect(() => {
    setProfileName(editingProfile?.name ?? '')
    setClick(false)
    setError(false)
  }, [editingProfile])

  const isEditMode = editingProfile !== null

  const saveProfile = async (name: string) => {
    const data: CreateProfileData = { name }
    try {
      if (isEditMode && editingProfile) {
        await ApiService.profiles.patch(editingProfile.id, data)
      } else {
        await ApiService.profiles.create(data)
      }
      setNewProfiles(() => newProfiles + 1)
      setModalActive(false)
    } catch (error: any) {
      if (error.response?.status === 409) {
        setError(true)
      }
      console.error(isEditMode ? 'Erro ao atualizar perfil' : 'Erro ao criar perfil', error)
    }
  }
  
  return (
    <Container>
      <HeaderDiv>
        <HeaderText>{isEditMode ? 'Editar perfil' : 'Criar novo'}</HeaderText>
        <CloseDiv onClick={() => setModalActive(false)}>
            <CloseImg src={cross} alt='Close tab'/>
        </CloseDiv>
      </HeaderDiv>
      <InputDiv>
        <LabelCreate>Insira o nome do perfil</LabelCreate>
        {error ? <ErrorMessage>Perfil com este nome já existente</ErrorMessage> : null}
        {isReservedName ? <ErrorMessage>Nome &quot;ADM&quot; é reservado e não pode ser usado</ErrorMessage> : null}
        <InputProfileName 
          placeholder='Digite aqui'
          type='text'
          onChange={(event) => setProfileName(event.target.value)}
          value={profileName}
        />
      </InputDiv>
      <ButtonsDiv>
        {!correctName ? (
          <>
          {click ? (
            <TipText>
              {isReservedName ? 'Nome "ADM" é reservado' : 'Deve conter pelo menos 3 letras'}
            </TipText>
          ) : null}
          <CreateButtonDiv onClick={() => setClick(true)}>
            <CreateButtonImage src={plus} alt='Plus icon'/>
            <CreateButtonText>{isEditMode ? 'Atualizar perfil' : 'Criar perfil'}</CreateButtonText>
          </CreateButtonDiv>
          </>
        ) : (
          <CreateButtonDiv onClick={() => saveProfile(profileName.trim())}>
            <CreateButtonImage src={plus} alt='Plus icon'/>
            <CreateButtonText>{isEditMode ? 'Atualizar perfil' : 'Criar perfil'}</CreateButtonText>
          </CreateButtonDiv>
        )}
      </ButtonsDiv>
    </Container>
  )
}

export default CreateProfile
